/**
 * Map zeecore /utilisation/v2 vehicle-day rows into FleetReport CSVRow shape.
 */

import type { TruthUtilisationVehicleDayRow } from '../types/utilisationTruth';

export type UtilisationCsvRow = Record<string, string>;

export function isTruthUtilisationCsvRow(row: Record<string, unknown>): boolean {
  return row.truth_layer === '1';
}

/** Convert a truth API row to the pseudo-CSV shape FleetReport already understands. */
export function truthUtilisationRowToCsvRow(row: TruthUtilisationVehicleDayRow): UtilisationCsvRow {
  const productive =
    row.productive_hours ??
    ((row.active_hours ?? 0) + (row.idle_hours ?? 0));

  return {
    truth_layer: '1',
    date: row.date,
    vehicle: row.vehicle,
    Vehicle_ID: row.vehicle,
    vehicle_id: row.vehicle,
    vehicle_type: row.vehicle_type ?? '',
    VehicleType: row.vehicle_type ?? '',
    total_miles: String(row.total_miles ?? 0),
    miles: String(row.total_miles ?? 0),
    num_trips: String(row.num_trips ?? 0),
    trips: String(row.num_trips ?? 0),
    active_hours: String(row.active_hours ?? 0),
    idle_hours: String(row.idle_hours ?? 0),
    downtime_hours: String(row.downtime_hours ?? 0),
    productive_hours: String(productive),
    revenue_gbp: row.revenue_gbp != null ? String(row.revenue_gbp) : '',
    avg_laden_percentage:
      row.avg_laden_percentage != null ? String(row.avg_laden_percentage) : '',
    mileage_efficiency_pct: String(row.mileage_efficiency_pct ?? 0),
    time_efficiency_pct: String(row.time_efficiency_pct ?? 0),
    revenue_efficiency_pct:
      row.revenue_efficiency_pct != null ? String(row.revenue_efficiency_pct) : '',
    load_efficiency_pct:
      row.load_efficiency_pct != null ? String(row.load_efficiency_pct) : '',
    utilisation_score: String(row.utilisation_score ?? 0),
    utilisation_rate: row.utilisation_rate != null ? String(row.utilisation_rate) : '',
    target_mileage_miles: String(row.target_mileage_miles ?? 0),
    target_driving_hours: String(row.target_driving_hours ?? 0),
    target_waiting_hours: String(row.target_waiting_hours ?? 0),
    target_revenue_gbp: row.target_revenue_gbp != null ? String(row.target_revenue_gbp) : '',
  };
}
